import React, { useContext } from 'react';
import { Box, Button } from '@mui/material';
import AccordionSettings from '../../../../../Components/AccordionSettings';
import { MultiSplitTestExperimentCard } from './Components/MultiSplitTestExperimentCard';
import AbSplitTestExperimentCard from './Components/AbSplitTestExperimentCard';
import commonStyles from '../../../../../commonStyles';
import AddNewExperimentModalContent from './AddNewExperimentModal';
import AddCircleOutlineOutlined from '@mui/icons-material/AddCircleOutlineOutlined';
import { Modalv2Context } from '../../../../../Contexts/Modalv2Context';

export const ExperimentSection = ({
	expbDoc,
	userHasExpbDocEditAccess,
	addNewExperiment,
	units
}) => {
	const { experiments } = expbDoc;
	const commonStyleClasses = commonStyles();
	const { updateModalContent } = useContext(Modalv2Context);

	return (
		<Box
			className={commonStyleClasses.basicOutlinedBox}
			style={{ width: '94%', margin: '3rem auto 0 auto' }}
		>
			{expbDoc &&
			userHasExpbDocEditAccess &&
			Object.keys(units).some((sectionRef) => !units[sectionRef].abSplitTestData) ? (
				<Box textAlign="center">
					<Button
						variant="contained"
						sx={{ gap: '0.5rem', px: '2rem', py: '1rem', mt: '2rem' }}
						onClick={() =>
							updateModalContent(
								<AddNewExperimentModalContent addNewExperiment={addNewExperiment} />
							)
						}
					>
						Create New Experiment
						<AddCircleOutlineOutlined fontSize="small" sx={{ color: 'white' }} />
					</Button>
				</Box>
			) : (
				<Box textAlign="center" sx={{ mt: '2rem', width: '80%', mx: 'auto', fontWeight: 700 }}>
					To add an experiment split create a new section since no control section is currently
					available.
				</Box>
			)}

			{Array.isArray(experiments) &&
				experiments.map((experiment, index) => {
					return (
						<AccordionSettings
							label={experiment.experimentName}
							chipData={experiment.status}
							key={index}
							accordionStyles={{
								width: '90%',
								margin: '5rem auto',
								boxShadow: 'unset'
							}}
							accordionDetailStyles={{
								backgroundColor: 'white',
								border: '1px solid darkgrey',
								borderTop: '0px'
							}}
						>
							{experiment.multiSplit ? (
								<MultiSplitTestExperimentCard experimentData={experiment} index={index} />
							) : (
								<AbSplitTestExperimentCard experimentData={experiment} index={index} />
							)}
						</AccordionSettings>
					);
				})}
		</Box>
	);
};
